import React, { PropsWithChildren } from "react";
//#region types
import { ProgressMessageProps } from "models/propTypes/messagePropTypes";
//#endregion
//#region components
import { CircularProgress, Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ProgressMessage: React.FC<PropsWithChildren<ProgressMessageProps>> = (props) => {
  return (
    <Grid container direction="row" wrap="nowrap" className={props.className}>
      <Grid item>
        <CircularProgress size={12} className={cssExports.messageBubbleProgress} />
      </Grid>
      <Grid item>{props.children}</Grid>
    </Grid>
  );
};

export default ProgressMessage;
